<template>
  <teleport to="body">
    <div class="SPADownloadLoader" :class="{ isOpen: isOpen }">
      <img src="@/assets/images/2024/sproutspinner-white.gif" alt="download-loader-img" />
    </div>
  </teleport>
</template>
<style lang="scss" scoped>
.SPADownloadLoader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1065;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.8);
  opacity: 1;
  display: none;
  padding-right: 0px;
  pointer-events: none;

  img {
    width: 72px;
  }

  &.isOpen {
    display: grid;
    place-content: center;
  }
}
</style>
<script>
export default {
  name: 'SPADownloadLoader',
  props: {
    isOpen: { type: Boolean, default: false },
  },
  setup(props) {
    return {
      ...props,
    };
  },
};
</script>
